"use client";

const IMAGES = [
  { src: "/usdt_asset.svg", alt: "usdt" },
  { src: "/usdc_asset.svg", alt: "usdc" },
  { src: "/eth_asset.svg", alt: "eth" },
  { src: "/btc_asset.svg", alt: "btc" },
  { src: "/sol_asset.svg", alt: "sol" },
];

export default function ActiveCountries() {
  const track = [...IMAGES, ...IMAGES, ...IMAGES];

  return (
    <section className="py-20 md:py-36">
      <div className="px-4 flex justify-center text-center mb-6">
        <p className="font-semibold text-[26px] sm:text-[30px] md:text-[34px] lg:text-[36px] leading-[32px] md:leading-[38px] lg:leading-[42px] tracking-[-0.9px] text-[#010721] font-onest max-w-[40rem]">
          Convert other Cryptocurrency Assets
        </p>
      </div>
      <div className="relative w-full flex items-center bg-white overflow-hidden">
        {/* Scrolling flags, sits underneath the pill */}
        <div className="flex items-center pl-28 sm:pl-36 md:pl-48 lg:pl-56 xl:pl-64">
          <div
            className="flex items-center gap-2 sm:gap-3 md:gap-4"
            style={{ animation: "flagScroll 15s linear infinite" }}
          >
            {track.map((image, i) => (
              <div key={i} className="flex-shrink-0">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-[50px] h-[50px] sm:w-[90px] sm:h-[90px] md:w-[110px] md:h-[110px] lg:w-[130px] lg:h-[130px] xl:w-[150px] xl:h-[150px]"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Fixed green pill, left side, on top */}
        <img
          src="/supported_assets.svg"
          alt=""
          className="absolute left-0 top-0 w-[200px] md:w-auto"
        />

        <style>{`
        @keyframes flagScroll {
          0% { transform: translateX(-33.333%); }
          100% { transform: translateX(0%); }
        }
      `}</style>
      </div>
    </section>
  );
}
